import { useEffect, useState } from 'react';
import type { Consent } from './tracker';
import { getConsent, resetConsent, subscribeConsent } from './tracker';
import './analytics.css';

const consentLabels: Record<Consent, string> = { accepted: 'cookie аналитики разрешены', declined: 'cookie аналитики отклонены' };

/** Privacy-page control: shows the current choice (after mount, SSR-safe) and re-opens the banner. */
export function CookieSettings() {
  const [consent, setConsentState] = useState<Consent | null | undefined>(undefined);
  useEffect(() => {
    setConsentState(getConsent());
    return subscribeConsent((value) => setConsentState(value));
  }, []);
  return <p className="cookie-settings">
    <button type="button" className="cookie-banner__button" onClick={resetConsent}>Настройки cookie</button>
    <span aria-live="polite">{consent === undefined ? '' : consent ? `Сейчас: ${consentLabels[consent]}.` : 'Выбор не сделан — баннер с вариантами показан внизу страницы.'}</span>
  </p>;
}
